import React from 'react'
import { Card, ProgressBar } from 'react-bootstrap';
import { Error404 } from '../../../Library/LoaderPage';

export function CPDPCategories({ data }) {
    if (Object.values(data).length === 0) return <Error404 />;

    const sort_data = data.sort((a, b) => a.no - b.no);
    const data_categ = sort_data.filter(item => item.minimum_points !== null);
    const data_categ_no_min = sort_data.filter(
        (item) => item.minimum_points === null
    );

    return (
        <Card>
            <Card.Body className='px-0 py-1'>
                <h3 className='my-8 px-8'>CPDP Points Progress by Category</h3>
                {data_categ && Object.values(data_categ).length > 0 ?
                    data_categ.map((v, index) => (
                        <RenderProgressBar data={v} key={index} />
                    )) : <Error404 />}

                {data_categ_no_min && Object.values(data_categ_no_min).length > 0 && (
                    <div className="row mt-5 px-8">
                        <div className="col-12">
                            <h3>Other Categories</h3>
                        </div>
                        {data_categ_no_min.map((v, index) => (
                            <div className="col-auto mb-5">
                                <div className="border rounded p-5" key={index}>
                                    <label className="font-weight-bold d-block">
                                        {v?.category}: {v?.type}
                                    </label>
                                    <span className={`${v?.points > 0 ? 'text-primary' : 'text-muted'}`}>Earn Points: {v?.points}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}


const RenderProgressBar = ({ data }) => {
    const points = data?.points || 0;
    const minim = data?.minimum_points || 0;
    const progress = Math.round((points / minim) * 100);
    const remaing_points = minim - points;
    return (
        <div className='my-0'>
            <div className="px-8 my-5">
                <GraphProgressBar title={`${data?.category}: ${data?.type}`} persentage={progress >= 100 ? 100 : progress} color='primary' />
                <div className="d-flex align-items-center justify-content-between">
                    <span className="text-muted">
                        {points}/{minim} pts {" "}
                        {points >= minim ? 'Completed' : 'Incomplete'}
                    </span>
                    {points < minim && (
                        <span className="text-warning">{remaing_points} pts needed</span>
                    )}
                </div>
            </div>
            <div className="separator separator-dashed"></div>
        </div>
    )
}

const GraphProgressBar = ({ title, persentage, color = 'success' }) => {
    return (
        <div>
            {title && (
                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                    <span className="fw-bold fs-6 text-gray-500">{title}</span>
                    {/* <span className={`fw-bolder fs-6 ms-2 text-${color}`}>{persentage}%</span> */}
                </div>
            )}
            <ProgressBar>
                <ProgressBar variant={color} now={persentage} key={1} />
            </ProgressBar>
        </div>
    )
}